import { Component, OnDestroy, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DataSource } from '@angular/cdk/collections';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { fuseAnimations } from '@fuse/animations';

///IDIOMAS
import { lang_configuracion } from '../../../../idiomas/i18n/configuracion/configuracion.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

@Component({
    selector     : 'upload-logo',
    templateUrl  : './uploadlogo.component.html',
    styleUrls    : ['./uploadlogo.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations : fuseAnimations
})
export class UploadLogoComponent {

  centered = false;
  disabled = false;
  unbounded = false;

  radius: number;
  color: string;

  constructor(
      private _fuseTranslationLoaderService: FuseTranslationLoaderService
  )
  {
      //this._fuseTranslationLoaderService.loadTranslations(lang_configuracion);
      lang_configuracion.forEach((locale) => {
          this._fuseTranslationLoaderService.loadTranslations(locale);
      });
  }

}
